<template>
  <div class="container">
    <div class="row">
      <div class="container-fluid">
	<h3 class="title">MES COMPETENCES TECHNIQUES - HARD SKILLS</h3>
        <h5>Cliquez sur les compétences pour avoir plus de détails</h5>
	<div v-for="(value, key) in competences_hard" :key="key" class="maj_comp">
          <h4>{{ key.toUpperCase() }}</h4>
	<div v-for="(competence, index) in value" :key="index" class="div_card" @click="toggleList(key, index)">
            <img class="icone" :src="getImg(competence.img)" alt="Image non trouvée">
            <div>
              <h5 class="title_comp">{{ competence.nom }}</h5>
				<ul v-if="selectedCategory === key && selectedCompetence === index">
					<li v-for="(item, ind) in competence.description[0]" :key="ind">
						{{ item }}
					</li>
				</ul>
            </div>
	  </div>
        </div>
	
	<h3 class="title">MES COMPETENCES RELATIONNELLES - SOFT SKILLS</h3>
	
	<div v-for="(value, key) in competences_soft" :key="key" class="maj_comp">
          <h4>{{ key.toUpperCase() }}</h4>
                <div v-for="(competence, index) in value" :key="index" class="div_card" >
            <img class="icone" :src="getImg(competence.img)" alt="Image non trouvée">
            <div>
              <h5 class="title_comp">{{ competence.nom }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "Competences",
  props: ["competences_hard", "competences_soft"],
  data() {
	return {
		selectedCategory: null,
		selectedCompetence: null,
	}
  },
  methods: {
	getImg(img) {
		return require('../../public/img/' + img);
	},
toggleList(category, index) {
      if (this.selectedCategory === category && this.selectedCompetence === index) {
        // Déselectionner la compétence si elle était déjà sélectionnée
        this.selectedCategory = null;
        this.selectedCompetence = null;
      } else {
        // Sélectionner la compétence si elle n'était pas encore sélectionnée
        this.selectedCategory = category;
        this.selectedCompetence = index;
      }
  }}
};
</script>

<style>


.maj_comp {
	display: inline-block;
	position: relative;
}

.div_card {
	display: inline-block;
	margin: 15px;
	padding: 20px;
	box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2);
}

.div_card:hover {
	box-shadow: 0px 10px 50px 0px rgba(0,0,0,0.2);	
}

.title_comp {
	margin: 0px;
	padding: 5px;
}

.icone {
	margin:auto;
	width: 50px;
	height: 50px;
}

.card-title {
	padding: 0px;
}

</style>

